<template>
  <div class="pageContainer">
    <div class="info-h5">
      <div class="form-title">
        <div class="left-text">预约试驾</div>
        <div class="right-button" @click="$emit('close')">收起</div>
      </div>
      <el-form :inline="true" class="demo-form-inline" :model="driveForm" ref="driveForm">
        <!-- 省份 / 城市 -->
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="*所在省份">
              <el-select v-model="driveForm.Province" placeholder="省份" @change="setProvince" @focus="focusDo">
                <el-option v-for="(item, key) in (alldata ? alldata.province : [])" :value="item.id" :key="key" :label="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="*所在城市">
              <el-select v-model="driveForm.City" placeholder="城市" @click="setCity()"
                         code-stm="event, PAGEURL, 切换城市信息mob" @change="cityChange">
                <el-option v-for="(item, key) in this.cascadingCities" :value="item.id" :key="key" :label="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 经销商 / 姓名 -->
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="*经销商">
              <el-select
                v-model="driveForm.DealerCode"
                placeholder="请选择经销商"
                @change="dealerChange"
                popper-class="select-option-dealer"
              >
                <el-option
                  v-for="(item, key) in this.cascadingDealers"
                  :key="key"
                  :value="item.code"
                  :label="item.name"
                  :disabled="item.isDisabled"
                >
                  <template #default>
                    <div  style="display: flex;align-items: start;padding: 5px 0;">
                      <i v-if="driveForm.DealerCode == item.code" class="el-icon-check" style="padding-top: 10px;font-weight: 600;"></i>
                      <div v-else style="width: 14px;height: 14px;"></div>
                      <div style="padding-left: 6px;" >
                        <div>{{ item.name }}</div>
                        <div class="ellipsis-text" style="color: rgba(180, 183, 192, 1);font-size: 12px;line-height: 20px;">{{ item.address }}</div>
                      </div>
                    </div>
                  </template>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="*购车人姓名">
              <el-input v-model="driveForm.Name" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div id="captcha-element"></div>
        <!-- 手机号 / 验证码 -->
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="*购车人手机号">
              <el-input v-model="driveForm.Phone" placeholder="请输入手机号" maxlength="11"
                        oninput="if(value.length > 11) value=value.slice(0, 11)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="*验证码" class="code-item">
              <el-input
                placeholder="请输入验证码"
                class="input code-input"
                v-model="driveForm.verificationCode"
                maxlength="6"
                oninput="if(value.length > 6) value=value.slice(0, 6)"
              />
            <div class="code-line"></div>
              <el-button
                class="button code-button"
                id="buttonAliyunCaptcha"
                code-stm="event, PAGEURL, 发送验证码mob"
                :class="{ disabled: !this.countDownCanClick }"
                :disabled="!this.countDownCanClick"
                >{{ countDownContent }}</el-button
              >
          </el-form-item>
          </el-col>
        </el-row>

        <!-- 车型（保持整行显示或按需要放置到任意位置） -->
        <!-- <el-form-item label="*车型">
          <el-select v-model="driveForm.CarSeriesCMSID" placeholder="请选择车型" @change="setCarSeries">
            <el-option v-for="item in carAlldata.series" :key="item.name" :value="item.cmsid" :label="item.name">
            </el-option>
          </el-select>
        </el-form-item> -->

        <el-row class="my-checkbox">
          <el-checkbox v-model="driveForm.checked" className="agreement-checkbox"  @change="checkboxChange">
            <span style="display: flex;color: #05141F99;white-space: nowrap;">
              已阅读并同意<span style="text-decoration: underline;color: #05141F;white-space: nowrap;" @click="read" code-stm="event, PAGEURL, 隐私协议">《隐私协议》</span>，且同意起亚经销商与我联系。
            </span>
          </el-checkbox>
        </el-row>

        <span class="submit-button" @click="submitInformation" code-stm="event, PAGEURL, 提交预约试驾表单信息mob">提交信息</span>
      </el-form>
    </div>
  </div>

</template>

<script>
import { getUrlKey, isPortraitFun, isAndroid } from "@/utils/utils.js";
import { apiUrl, pcdUrl, CSMUrl } from "@/config/base";
// import myBMap from "@/utils/myBMap";
import $ from "jquery";
export default {
  data() {
    return {
      captcha: null,
      isPortrait: isPortraitFun(),
      isAndroid: isAndroid(),
      alldata: null,
      carAlldata: null,
      closeIcon: "@/assets/images/onepage/close.png",
      // downArrowIcon: require("@/assets/images/footer/down-arrow.gif"),

      carModelSeries: [],
      cascadingCities: [],
      cascadingDealers: [],
      // canCheck: false,
      totalTime: 60,
      countDownContent: "发送验证码",
      countDownCanClick: true,
      clock: null,
      driveForm: {
        //试驾
        Phone: "",
        Name: "",
        verificationCode: "",
        Province: "",
        City: "",
        CarSeriesCMSID:'447',
        CarSeriesName: "新狮铂拓界",
        CarModelCMSID: "1617",
        CarModelName: "1.5T 舒适版",
        DealerName: "",
        DealerCode: "",
        checked: false,
      },

      params: null, // 留资参数

      currentBackground:'/assets/~/media/images/activity/film2505-prod/mob/bg.jpg',
    };
  },
  props: {
    clientPosition: {
      type: Object,
      default: null,
    },
  },

  created: function () {
    if (!this.alldata) {
      console.log("try to fetch alldata from created");
      this.$axios.get(pcdUrl).then((res) => {
        console.log("fetched alldata from created", res.data);
        //筛选省份 只保留 河南16，浙江11，湖北17、上海9、江苏10
        // const idsToKeep = ['16', '11', '17', '9', '10'];
        // const filteredProvinces = res.data.province.filter(obj => idsToKeep.includes(obj.id));
        // res.data.province = filteredProvinces;
        this.alldata = res.data;
        
        this.initData();
      });
    }
    window.addEventListener("resize", this.setResize);
  },
  mounted() {
    this.$nextTick(() => {
      // console.log("获取位置");
      // this.getLocation()
    });
    this.$nextTick(() => {
      this.ensureCaptchaReady();
    });
  },
  watch: {
    // 地址定位
    clientPosition: {
      handler(val) {
        // 防止定位完成省市信息没有加载完成
        if (!this.alldata) {
          this.$axios.get(pcdUrl).then((res) => {
            //筛选省份 只保留 河南16，浙江11，湖北17、上海9、江苏10
            // const idsToKeep = ['16', '11', '17', '9', '10'];
            // const filteredProvinces = res.data.province.filter(obj => idsToKeep.includes(obj.id));
            // res.data.province = filteredProvinces;
            this.alldata = res.data;
            this.initData();
            if (val && this.alldata && this.alldata.province) {
              const provinceMatch = this.alldata.province.filter(
                (item) => item.name == val.province
              )[0];
              if (provinceMatch) {
                this.driveForm.Province = provinceMatch.id;
                this.setCity(true);
                if (this.alldata.city && this.alldata.city[this.driveForm.Province]) {
                  const cityMatch = this.alldata.city[this.driveForm.Province].filter((item) => item.name == val.city)[0];
                  if (cityMatch) {
                    this.driveForm.City = cityMatch.id;
                    this.cityChange(this.driveForm.City);
                  }
                }
              }
            }
          });
        } else {
          if (val && this.alldata && this.alldata.province) {
            const provinceMatch = this.alldata.province.filter(
              (item) => item.name == val.province
            )[0];
            if (provinceMatch) {
              this.driveForm.Province = provinceMatch.id;
              this.setCity(true);
              if (this.alldata.city && this.alldata.city[this.driveForm.Province]) {
                const cityMatch = this.alldata.city[this.driveForm.Province].filter((item) => item.name == val.city)[0];
                if (cityMatch) {
                  this.driveForm.City = cityMatch.id;
                  this.cityChange(this.driveForm.City);
                }
              }
            }
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ensureCaptchaReady() {
      this.waitForCaptchaElements()
        .then(() => {
          this.initCaptcha();
        })
        .catch((err) => {
          console.warn(err?.message || "captcha elements not ready");
        });
    },
    waitForCaptchaElements(retries = 30, interval = 100) {
      return new Promise((resolve, reject) => {
        const attempt = () => {
          const element = document.querySelector("#captcha-element");
          const button = document.querySelector("#buttonAliyunCaptcha");
          if (element && button) {
            resolve({ element, button });
            return;
          }
          if (retries <= 0) {
            reject(new Error("captcha elements missing"));
            return;
          }
          retries -= 1;
          window.setTimeout(attempt, interval);
        };
        attempt();
      });
    },

    initCaptcha() {
      //***验证start
      console.log('initCaptcha diyici');
      var that = this;
      var preText = '';
      if (!window.location.href.includes("https://www.kia.cn")) {
        preText = 'https://uat.kia.cn'
      }else{
        preText = 'https://www.kia.cn'
      }
      let kiaLogoUrl = preText + '/assets/~/media/images/aliyuncaptcha/kia_logo.png';
      // 弹出式，除region和prefix以外的参数
      window.initAliyunCaptcha({
      // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      SceneId: "nrr27cp0",
      // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
      mode: "popup",
      // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      element: "#captcha-element",
      // 触发验证码弹窗或无痕验证的元素
      button: "#buttonAliyunCaptcha",
      captchaLogoImg: kiaLogoUrl,
      // 验证码验证通过回调函数
      success: function (captchaVerifyParam) {
        // 入参为验签captchaVerifyParam
        // 1.向后端发起业务请求进行验证码验签captchaVerifyParam校验
        // 2.根据校验结果来进行业务处理
        // 3.如业务需要重新进行验证码验证，调用验证码初始化方法initAliyunCaptcha重新初始化验证码
          console.log('captchaVerifyParam',captchaVerifyParam);
          that.countDown(captchaVerifyParam)
      },
      // 验证码验证不通过回调函数
      fail: function (result) {
        // 入参为不通过信息
        // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
        console.error(result);
      },
      // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
      getInstance: function (instance) {
        that.captcha = instance;
      },
      // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。
      slideStyle: {
        width: 360,
        height: 40,
      },
      // ...其他参数，参考initAliyunCaptcha参数说明
      });
      //***验证 end */
    },

    focusDo(){},
    checkboxChange(e){
      if(e == true){
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '勾选', 1]);
      }else{
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '取消勾选', 1]);
      }
    },
    read() {
      this.$router.push({
        path: "/terms",
      });
    },
    toTerms() {
      this.$router.push({
        path: "/terms",
      });
    },
    handleCheckboxChange(e) {
      console.log("handleCheckboxChange");
      this.driveForm.checked = !this.driveForm.checked;
      if(e == true){
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '勾选', 1]);
      }else{
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '取消勾选', 1]);
      }
    },
    close() {
      this.$emit("close");
    },
    initData() {
      let that = this;
      // this.$axios.get(CSMUrl).then((res) => {
      //   console.log("车型车款数据", res.data);
      //   that.carAlldata = res.data;
      // });
      fetch(CSMUrl).then(function (response) {
        return response.json();
      }).then(function (data) {
        console.log("车型车款数据", data);
        //只要狮铂拓界
        // data.series = data.series.filter(obj => obj.cmsid == '430');
        that.carAlldata = data;
      });
    },
    autoSet(a) {
      // let rs = this.clientPosition
      let rs = a;
      if (this.alldata && this.alldata.province) {
        let theProv = this.alldata.province.find(
          (res) => res.name == rs.addressComponents.province
        );
        // console.log(theProv);
        if (theProv) {
          this.driveForm.Province = theProv.id;
        }
      }
      this.setProvince();



      let theCity = this.cascadingCities.find(
        (res) => res.name == rs.addressComponents.city
      );
      if (theCity) {
        this.driveForm.City = theCity.id;
      }
      this.setCity();
    },
    setResize() {
      // console.log(13123, this.isPortrait);
      this.isPortrait = isPortraitFun();
    },
    setProvince() {
      this.driveForm.City = "";
      this.setCity();
    },
    // setCity() {
    //   // this.cascadingCities = this.alldata.city[this.driveForm.Province];
    //   this.cascadingCities = [];
    //   this.alldata.city[this.driveForm.Province].forEach((cityIter) => {
    //     //过滤city
    //     if (
    //       this.alldata.cityRelType[cityIter.id].includes("1") ||
    //       this.alldata.cityRelType[cityIter.id].includes("4")
    //     ) {
    //       this.cascadingCities.push(cityIter);
    //     }
    //   });
    //   this.driveForm.City = this.driveForm.City || this.cascadingCities[0].id;
    //   this.cityChange(this.driveForm.City);
    // },
    setCity(fromLocation = false) {
      // this.cascadingCities = this.alldata.city[this.driveForm.Province];
      this.cascadingCities = [];
      if (this.alldata && this.alldata.city && this.alldata.city[this.driveForm.Province]) {
        this.alldata.city[this.driveForm.Province].forEach((cityIter) => {
          //河南16，浙江11，湖北17、上海9、江苏10
          //过滤city 并只保留 郑州186，武汉203，上海107，苏州112，南京108，杭州121
          if (
            this.alldata.cityRelType && 
            this.alldata.cityRelType[cityIter.id] && 
            (this.alldata.cityRelType[cityIter.id].includes("1") ||
            this.alldata.cityRelType[cityIter.id].includes("4"))
            // && (cityIter.id == '186' || cityIter.id == '203' || cityIter.id == '107' || cityIter.id == '112' || cityIter.id == '108' || cityIter.id == '121')
          ) {
            this.cascadingCities.push(cityIter);
          }
        });
      }
      if(!fromLocation){
        this.driveForm.City = this.driveForm.City || this.cascadingCities[0].id;
      }else{
        // #如果未找到对应城市数据(因为他没有经销商 所以alldata城市字典表中没这个城市),则默认选中第一个
        // this.driveForm.City = this.cascadingCities.find((city) => city.name === this.clientPosition.city)?.id || this.cascadingCities[0].id
        if(!this.cascadingCities.find((city) => city.id === this.driveForm.City)){
          this.driveForm.City = ''
        }
      }
      this.cityChange(this.driveForm.City);
    },

    setCarSeries(e) {
      this.driveForm.CarModelCMSID = "";
      console.log(
        "this.driveForm.CarSeriesCMSID",
        this.driveForm.CarSeriesCMSID
      );
      if (this.driveForm.CarSeriesCMSID) {
        this.driveForm.CarModelCMSID =
          this.carAlldata.model[this.driveForm.CarSeriesCMSID].at(-1).cmsid;
        this.driveForm.CarModelName =
          this.carAlldata.model[this.driveForm.CarSeriesCMSID].at(-1).name;
      }
      console.log("this.driveForm.CarModelName", this.driveForm.CarModelName);

      //切换背景
      // var background = this.backGroundList.find(
      //   (item) => item.id == e
      // )?.background;
      // this.currentBackground = background;
    },
    async cityChange(cityId) {
      let map = await this.load();
      let baiduMap = new map.Map();
      //改变经销商数据/起点
      if (this.alldata && this.alldata.dealer && this.alldata.dealer[cityId]) {
        let temp = this.alldata.dealer[cityId];
      this.cascadingDealers = [];
      temp?.forEach((origin) => {
        if (origin.type == "1" || origin.type == "7") {
          const originPosition = new BMap.Point(
            origin.latitude,
            origin.longitude
          );
          const nowPosition = new BMap.Point(
            this.clientPosition.lng,
            this.clientPosition.lat
          );
          if (origin.isException !== "是" 
          && origin.name !== "上海森那美正大乐城城市展厅" && origin.name !== "武汉峻能凯德城市展厅"
          && origin.name !== "北京森那美北投城市展厅" && origin.name!== "济南金万通万达城市展厅"
          && origin.name!== "重庆现代高新南坪万达城市展厅" 
          ) {
            this.cascadingDealers.push({
              ...origin,
              distance: this.getMapDistance(
                nowPosition,
                originPosition,
                baiduMap
              ),
              isDisabled: origin.isException === "是",
            });
          }
        }
      });

      this.cascadingDealers = this.cascadingDealers.sort((a, b) => {
        // 首先处理 isException 的情况
        if (a.isException === "是" && b.isException !== "是") {
          return 1; // a 排在 b 后面
        } else if (a.isException !== "是" && b.isException === "是") {
          return -1; // b 排在 a 后面
        }
        return a.distance - b.distance;
      });
      if (this.cascadingDealers.length) {
        this.driveForm.DealerCode = this.cascadingDealers[0].code;
        this.driveForm.DealerName = this.cascadingDealers[0].name;
      }
      }
    },
    getMapDistance(centerPoint, otherPoint, map) {
      let distance = map.getDistance(centerPoint, otherPoint);
      return (distance / 1000).toFixed(2);
    },
    findMinIndex(arr) {
      if (!Array.isArray(arr) || arr.length === 0) {
        return 0;
      }
      let minIndex = 0;
      for (let i = 1; i < arr.length; i++) {
        if (arr[i] < arr[minIndex]) {
          minIndex = i;
        }
      }
      return minIndex;
    },
    dealerChange(dealerCode) {
      let dealer = this.cascadingDealers.find((value) => {
        return value.code === dealerCode;
      });
      this.driveForm.DealerCode =
        dealer == null ? this.cascadingDealers[0].code : dealer.code;
      this.driveForm.DealerName =
        dealer == null ? this.cascadingDealers[0].name : dealer.name;
    },
    countDown(captchaVerifyParam) {
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '机器人聊天-底部-预约试驾-发送验证码', 1]);
      stm_clicki("send",'event',window.location.href, "点击", '机器人聊天-底部-预约试驾-发送验证码');
      if (!this.driveForm.Phone) {
        this.$message.error("请填写正确的手机号");
        this.initCaptcha()
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.driveForm.Phone)) {
        this.$message.error("请填写正确的手机号");
        this.initCaptcha()
        return;
      }
      if (!this.countDownCanClick) return; //改动的是这两行代码
      this.countDownCanClick = false;
      this.countDownContent = this.totalTime + "s后重试";
      this.clock = window.setInterval(() => {
        this.totalTime--;
        this.countDownContent = this.totalTime + "s后重试";
        if (this.totalTime < 0) {
          window.clearInterval(this.clock);
          this.countDownContent = "重新发送";
          this.totalTime = 60;
          this.countDownCanClick = true; //这里重新开启
        }
      }, 1000);
      //发送验证码
      let getCodeData = {
        phoneNumbers: this.driveForm.Phone,
        captchaVerifyParam: captchaVerifyParam,
      };
      this.$axios
        .post(`${apiUrl}sendMsg/cityTour/CaptchaSendVerificationCode`, getCodeData)
        .then((res) => {
          console.log("ressssssss", res);
          if (res.data.success) {
            this.$message.info("验证码发送成功，请注意查收");
          } else {
            this.$message.error(res.data.message);
          }
          this.initCaptcha()
        });
    },
    submitInformation() {
      console.log("this su");
      if (
        !this.driveForm.Name ||
        !this.driveForm.Phone ||
        !this.driveForm.verificationCode ||
        !this.driveForm.CarSeriesCMSID
      ) {
        this.$message.error("请完善信息后再次提交");
        return;
      }
      // 验证手机号
      if (!/^1[3456789]\d{9}$/.test(this.driveForm.Phone)) {
        this.$message.error("请填写正确的手机号");
        return;
      }
      //获取车型名字
      // console.log(this.carSeries)
      let CarSeriesName = null;
      if (this.carAlldata && this.carAlldata.series) {
        CarSeriesName = this.carAlldata.series.find((item, index) => {
          return item.cmsid === this.driveForm.CarSeriesCMSID;
        });
      }
      //获取默认经销商名字和编码
      if (!this.driveForm.DealerCode || !this.driveForm.DealerName) {
        this.driveForm.DealerCode = this.cascadingDealers[0].code;
        this.driveForm.DealerName = this.cascadingDealers[0].name;
      }
      //将省市转化成字符串
      let provinceStr = null;
      let cityStr = null;
      if (this.alldata && this.alldata.province) {
        provinceStr = this.alldata.province.find(
          (item) => item.id === this.driveForm.Province
        );
      }
      if (this.alldata && this.alldata.city && this.alldata.city[this.driveForm.Province]) {
        cityStr = this.alldata.city[this.driveForm.Province].find(
          (item) => item.id === this.driveForm.City
        );
      }
      provinceStr = provinceStr?.name || '';
      cityStr = cityStr?.name || '';

      if (!this.driveForm.checked) {
        this.$message.error(
          "请先同意已阅读并同意《隐私协议》，且同意起亚经销商与我联系"
        );
        return;
      }
      let currentYear= new Date().getFullYear();
      let  currentMonth = new Date().getMonth() + 1;
      let activename  = "官网-AI预约试驾-预约试驾";

      let subFormDrive = {
        //媒体来源、活动来源、媒体渠道ID没写
        carModelCmsid: this.driveForm.CarModelCMSID,
        carModelName: this.driveForm.CarModelName,
        carSeriesCmsid: this.driveForm.CarSeriesCMSID,
        carSeriesName: CarSeriesName.name,
        cityName: cityStr,
        dealerCode: this.driveForm.DealerCode,
        dealerName: this.driveForm.DealerName,
        provinceName: provinceStr,
        userName: this.driveForm.Name,
        userPhone: this.driveForm.Phone,
        verificationCode: this.driveForm.verificationCode,
        smartCode: getUrlKey("utm_source") || "官网", //媒体来源
        activity: getUrlKey("utm_activity") || activename, //活动名称
        extraSix: getUrlKey("utm_soid") || "76",
      };
      // let subFormDrive = {
      //   //媒体来源、活动来源、媒体渠道ID没写
      //   CarSeriesCMSID: this.driveForm.CarModelCMSID,
      //   CarModelName: this.driveForm.CarModelName,
      //   CarModelCMSID: this.driveForm.CarSeriesCMSID,
      //   CarSeriesName: CarSeriesName.name,
      //   City: cityStr,
      //   DealerCode: this.driveForm.DealerCode,
      //   DealerName: this.driveForm.DealerName,
      //   Province: provinceStr,
      //   Name: this.driveForm.Name,
      //   Phone: this.driveForm.Phone,
      //   verificationCode: this.driveForm.verificationCode,
      //   SmartCode: getUrlKey("utm_source") || "官网", //媒体来源
      //   Activity: getUrlKey("utm_activity") || "EV5长续航上市", //活动名称
      //   ExtraSix: getUrlKey("utm_soid") || "76",
      // };
      //预约试驾接口
      this.$axios
        .post(`${apiUrl}clue/newkiaAaustralia/saveClue`, subFormDrive)
        .then((res) => {
          // this.$axios.post(`${apiUrl}Clue/TestDriveSaveClue`,subFormDrive).then((res) => {
          console.log(99999998888, res);
          if (res.data.success) {
            this.$message.success("预约试驾成功");
            

            setTimeout(() => {
              this.driveForm.CarModelCMSID = "1617";
              this.driveForm.CarSeriesCMSID = "447";
              this.driveForm.CarModelName = "";
              this.driveForm.DealerCode = "";
              this.driveForm.DealerName = "";
              this.driveForm.Name = "";
              this.driveForm.Phone = "";
              this.driveForm.verificationCode = "";
              this.driveForm.City = "";
              this.driveForm.Province = "";
              this.driveForm.checked = false;

              // 重置倒计时
              window.clearInterval(this.clock);
              this.countDownContent = "发送验证码";
              this.totalTime = 60;
              this.countDownCanClick = true;
            }, 1000);
            _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),
              '活动留资线索提交成功', JSON.stringify(subFormDrive)]);
          } else {
            this.$message.error("预约试驾失败:" + res.data.message);
            _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),
              '活动留资线索提交失败', JSON.stringify(subFormDrive)]);
          }
        });
    },
    // 加载地图
    load() {
      return new Promise((resolve, reject) => {
        if (!this.BMap) {
          $.getScript(
            "//api.map.baidu.com/api?v=2.0&ak=4ybCJ1rBffkf2PFgkvsRJuqAV9XBtnHq&callback=initialize",
            function (res) {
              console.log("百度", res);
              let num = 1;
              let time = setInterval(() => {
                if (BMap.Map) {
                  this.BMap = true;
                  resolve(BMap);
                  clearInterval(time);
                }
                num++;
              }, 25);
            }
          );
        } else {
          resolve(BMap);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 767px) {
  .select-option-dealer .el-select-dropdown__item {
    height: auto !important;
    // padding: 0 6px;
  }
  .pageContainer {
    .info-h5 {
      width: 100%;
      background-color: #ffffff;
      padding: calc(10 / 375 * 100vw) calc(20 / 375 * 100vw);
      .form-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: calc(10 / 375 * 100vw) 0;
        .left-text {
          font-size: calc(16 / 375 * 100vw);
          font-family: 'FZLanTingHeiS-DB-GB';
        }
        .right-button {
          font-size: calc(12 / 375 * 100vw);
          color: rgba(105, 114, 121, 1);
          cursor: pointer;
          font-family: 'FZLanTingHeiS-R-GB';
        }
      }

      ::v-deep .el-checkbox {
        display: flex;
        align-items: center;
      }
      ::v-deep .el-checkbox__label span {
        font-size: calc(10 / 375 * 100vw);
      }

      ::v-deep .el-input__inner {
        border: 1px solid rgba(238, 238, 238, 1);
        color: #05141F;
      }
      ::v-deep .el-checkbox__inner {
        border: 1px solid #05141F66 !important;
      }
    }

    /* 每个输入/选择框占一行 */
    ::v-deep .el-row {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
    }
    /* 覆盖 element 的 12 栅格，让其在移动端占满一行 */
    ::v-deep .el-col-12 {
      max-width: 100% !important;
      flex: 0 0 100% !important;
    }
    /* 覆盖 inline 表单项为块级 */
    ::v-deep .el-form--inline .el-form-item {
      display: block !important;
    }

    ::v-deep .el-form-item {
      margin: 0 0 calc(12 / 375 * 100vw) 0;
      width: 100%;
    }
    ::v-deep .el-form-item__label {
      display: none !important;
      width: 0 !important;
      padding: 0 !important;
    }
    ::v-deep .el-form-item__content {
      width: 100% !important;
      line-height: calc(36 / 375 * 100vw);
    }
    ::v-deep .el-input__icon {
      line-height: calc(36 / 375 * 100vw);
    }

    ::v-deep .el-select {
      width: 100%;
      background-color: rgba(248, 248, 248, 1);
      border-radius: calc(4 / 375 * 100vw);
      .el-input {
        height: calc(36 / 375 * 100vw);
      }
      .el-input__inner {
        height: calc(36 / 375 * 100vw);
        padding: 0 calc(12 / 375 * 100vw);
        background-color: rgba(248, 248, 248, 1);
        border: solid 1px rgba(238, 238, 238, 1);
        border-radius: calc(4 / 375 * 100vw);
        font-size: calc(12 / 375 * 100vw);
      }
    }

    ::v-deep .el-input__inner {
      border-radius: calc(4 / 375 * 100vw);
      height: calc(36 / 375 * 100vw);
      background-color: rgba(248, 248, 248, 1);
      border: solid 1px rgba(238, 238, 238, 1);
      color: #3d3d3d;
      padding: 0 calc(12 / 375 * 100vw);
      font-size: calc(12 / 375 * 100vw);
    }

    .submit-button {
      height: calc(40 / 375 * 100vw);
      border-radius: calc(4 / 375 * 100vw);
      font-size: calc(12 / 375 * 100vw);
      margin: calc(20 / 375 * 100vw) 0 calc(40 / 375 * 100vw) 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #000000;
      color: #FFFFFF;
    }

    .el-button {
      width: 100%;
      background: #000000;
      border-radius: 0px;
      height: calc(50 / 375 * 100vw);
      color: #000;
      border: none;
      font-size: calc(14 / 375 * 100vw);
    }
    .disabled {
      color: #a7a7a7 !important;
    }
    .code-item .code-button {
      background-color: rgba(248, 248, 248, 1);
      padding: 0 calc(20 / 375 * 100vw);
      font-weight: 400;
      width: auto;
      font-size: calc(12 / 375 * 100vw);
      height: calc(36 / 375 * 100vw);
      line-height: calc(36 / 375 * 100vw);
    }
    .code-input { flex: 1; }
    ::v-deep .code-input .el-input__inner { border: none !important; }
    .code-line {
      display: inline-block;
      width: 1px;
      height: calc(16 / 375 * 100vw);
      background-color: rgba(0, 0, 0, 0.2);
    }
    ::v-deep .code-item .el-form-item__content {
      background-color: rgba(248, 248, 248, 1);
      display: flex;
      align-items: center;
      border-radius: calc(4 / 375 * 100vw);
      border: solid 1px rgba(238, 238, 238, 1);
    }

    ::v-deep .el-checkbox__label span {
      display: block;
      color: #a7a7a7;
      // margin-top: calc(15 / 375 * 100vw);
      font-size: calc(12 / 375 * 100vw);
    }
  }
}
@media (min-width: 767px) {
.select-option-dealer .el-select-dropdown__item {
    height: auto !important;
    padding: 0 6px;
  }
  .select-option-dealer .el-select-dropdown__item.selected {
    font-weight: 500 !important;
  }
  .ellipsis-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: calc(100% - 45px);
  }
  .pageContainer {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .info-h5 {
      width: 100%;
      background-color: #ffffff;
      padding: 10px 20px;
      .form-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
        .left-text {
          font-size: 16px;
          font-family: 'FZLanTingHeiS-DB-GB';
        }
        .right-button {
          font-size: 12px;
          color: rgba(105, 114, 121, 1);
          cursor: pointer;
          font-family: 'FZLanTingHeiS-R-GB';
        }
      }
      ::v-deep .el-checkbox {
        display: flex;
        align-items: center;
        
      }
      ::v-deep .el-checkbox__label {
        margin-left: 0px;

        span {
          font-size: 10px;
        }
      }

      ::v-deep .el-input__inner {
        border: 1px solid rgba(238, 238, 238, 1);
        color: #05141F;
      }

      ::v-deep .el-checkbox__inner {
        border: 1px solid #05141F66 !important;
      }
    }
    ::v-deep .el-input__inner {
      height: 36px;
      line-height: 36px;
      font-size: 12px;
    }

    .el-button {
      height: 36px;
      background: #fff;
      color: #000;
    }

    .submit-button {
      height:  36px;
      border-radius: 4px;
      font-size: 12px;
      margin: 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #000000;
      color: #FFFFFF;
    }

    .el-row {
      box-sizing: border-box;
      
      display: flex;
      align-items: flex-end;
      // margin-bottom: 5px;
    }

    ::v-deep .el-form-item__content .inline-txt {
      position: absolute;
      line-height: 36px;
      padding: 0 10px;
      color: #05141F99;
    }
    
  }


  .el-button {
    width: 100%;
    background: #000000;
    border-radius: 0px;
    height: 50px;
    color: #fff;
    border: none;
  }

  ::v-deep .el-checkbox__label span {
    display: block;
    color: #a7a7a7;
    margin-top: 15px;
    font-size: 12px;
  }

  ::v-deep .el-checkbox__inner {
    background: transparent;
    border: 1px solid rgba($color: #000000, $alpha: 0.3);
  }

  /* 统一表单项间距 */
  ::v-deep .el-form-item {
    margin: 0 0 12px 0;
    width: 100%;
  }

  ::v-deep .el-input__icon {
    line-height: 36px;
  }

  /* 去掉所有表单项的 label */
  ::v-deep .el-form-item__label {
    display: none !important;
    width: 0 !important;
    padding: 0 !important;
  }
  /* 内容区域占满宽度 */
  ::v-deep .el-form-item__content {
    width: 100% !important;
    line-height: 36px;
  }

  ::v-deep .el-form--inline .el-form-item__label {
    display: none !important;
  }

  ::v-deep .el-select {
    width: 100%;
    background-color: rgba(248, 248, 248, 1);
    // background-color:#000;
    border-radius: 4px;
    .el-input {
      height: 36px;
    }
    .el-input__inner {
      // width: 43vw;
      height: 36px;
      // padding: 0 10px;
      padding: 0 calc(38 / 1125 * 100%);
      background-color: rgba(248, 248, 248, 1);
      // background-color:#000;
      border: solid 1px rgba(238, 238, 238, 1);
      border-radius: 4px;
    }
  }

  ::v-deep .el-input__inner {
    border-radius: 4px;
    // height: 50px;
    // line-height: 50px;
    height: 36px;
    // background: transparent;
    background-color: rgba(248, 248, 248, 1);
    border: solid 1px rgba(238, 238, 238, 1);
    color: #3d3d3d;
    padding: 0 calc(38 / 1125 * 100%);
  }

  ::v-deep .el-form--inline .el-form-item__label {
    display: block;
    text-align: left;
    color: #666666;
    // font-size: calc(37 / 1125 * 100%);
    font-size: 12px;
    width: calc(240 / 1125 * 100%);
    padding: 0;
    white-space: nowrap;
  }

  ::v-deep .el-checkbox__input {
    vertical-align: top;
  }

  ::v-deep .el-checkbox__label span {
    display: block;
    margin-top: 0px;
    white-space: pre-wrap;
  }

  .agreement-checkbox {
    display: flex;
    align-items: center;
  }
  ::v-deep .el-checkbox__inner::after {
    border: 1px solid #000 !important;
    border-left: 0 !important;
    border-top: 0 !important;
  }

  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    // background-color: #05141F;
    background-color: rgba(238, 238, 238, 1) !important;
    border-color: #05141F;
  }

  .disabled {
    color: #a7a7a7 !important;
  }

  .code-item .code-button {
    background-color: rgba(248, 248, 248, 1);
    padding: 0 5px;
    font-weight: 400;
    width: auto;
    font-size: 10px;
  }
  .code-input {
    flex: 1;
  }
  ::v-deep .code-input .el-input__inner {
    border: none !important;
  }
  .code-line {
    display: inline-block;
    width: 1px;
    height: 16px;
    background-color: rgba(0, 0, 0, 0.2);
  }
  ::v-deep .code-item .el-form-item__content {
    background-color: rgba(248, 248, 248, 1);
    display: flex;
    align-items: center;
    border-radius: 4px;
    border: solid 1px rgba(238, 238, 238, 1);
  }
}
</style>
